import { DoodEntityModel } from '@core/models/entity.model';
import { IAddress } from '@core/models/address.model';
import { IMetafield } from '@core/models/metafield.model';

export enum DoodAuthenticationStep {
  login = 'login',
  signup = 'signup',
}

/** User tag synced from external sources (e.g. Como) onto the DOOD account. */
export interface DoodUserTagModel {
  entity_type: 'marketplace' | 'shop' | 'organization' | string;
  entity_id: string;
  created_at?: string | Date;
  source: 'como' | string;
  label: string;
}

export interface DoodUserModel {
  id: string;
  firstname: string;
  lastname?: string;
  email?: string;
  phone?: string;
  avatar?: string;
  addresses?: IAddress;
  roles?: string[];
  entities?: DoodEntityModel[];
  legal_consents?: unknown[];
  legal_terms_accepted_at?: Date | null;
  is_anonymous: boolean;
  active?: boolean;
  created_at?: string | Date;
  updated_at?: string | Date;
  email_verified?: boolean;
  metafields?: IMetafield[];
  optin?: boolean;
  preferred_locales?: string[];
  custom_token?: string;
  /** Dood anonymous JWT (HS256). Present on POST /users/anonymous and some Como flows. */
  access_token?: string;
  token_type?: string;
  /** Seconds until Dood anonymous JWT expiry (typically 21600). */
  expires_in?: number;
  /** Tags from loyalty providers (Como, …), exposed by `/users/me`. */
  tags?: DoodUserTagModel[];
}

/** Response of POST /users/anonymous (201). */
export interface DoodAnonymousUserResponse extends DoodUserModel {
  access_token: string;
  token_type: string;
  expires_in: number;
}
